import { useState, useEffect } from 'react';

export type AddSubscriptionProductParameterType = {
  variantId: string;
  quantity: number;
  sellingPlanId: string;
  price: string;
  planPrice: string;
  btnTitle: string;
  btnClassName: string;
}

export const useGetProductFromParent = () => {
  const [productParameter, setProductParameter] = useState<AddSubscriptionProductParameterType>();

  useEffect(() => {
    const handleRecieveMessage = (event: MessageEvent) => {
      const { product } = event.data;
      if (!product) return;

      setProductParameter({
        ...productParameter,
        variantId: product.variantId,
        quantity: product.quantity,
        sellingPlanId: product.sellingPlanId,
        price: product.price,
        planPrice: product.planPrice,
        btnTitle: product.btnTitle,
        btnClassName: product.btnClassName,
      });
    };
    window.addEventListener('message', handleRecieveMessage);

    return () => window.removeEventListener('message', handleRecieveMessage);
  }, []);

  return productParameter;
};
